/**
 * Buddy's own picks the trainer opened to change (R8), in the order they were opened. A decision on
 * one moves its name from the draft's automatic matches into its unresolved exercises; the card
 * stays where it was opened, so the order is the opening order and never which list holds the name
 * now. Two open cards therefore never swap places when one of them is decided.
 *
 * Pure: no React, no i18next.
 */

import type { AiAutoMatch, AiUnresolvedExercise } from '~/entities/ai-conversation';

export type ChangingPick =
  /** Decided since it was opened: the server lists it among the unresolved exercises. */
  | { readonly kind: 'decided'; readonly exercise: AiUnresolvedExercise }
  /** Still Buddy's pick, open to change. */
  | { readonly kind: 'open'; readonly match: AiAutoMatch };

/**
 * @param opened The keys opened, in the order they were opened (a `Set` keeps insertion order).
 * @param keyOf  A name's key on this draft.
 */
export function changingPicks(
  opened: Iterable<string>,
  unresolved: readonly AiUnresolvedExercise[],
  autoMatched: readonly AiAutoMatch[],
  keyOf: (name: string) => string,
): readonly ChangingPick[] {
  return [...opened].flatMap((key): ChangingPick[] => {
    const exercise = unresolved.find((each) => keyOf(each.name) === key);
    if (exercise !== undefined) return [{ kind: 'decided', exercise }];
    const match = autoMatched.find((each) => keyOf(each.name) === key);
    return match === undefined ? [] : [{ kind: 'open', match }];
  });
}
